





























































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { namespace, Getter, Action } from "vuex-class";
import { DispatchRequest, DispatchNote, MobileFeatures } from "@/store/mobile/types";
import UploadFileButton from "@/components/mobile/dispatch/UploadFileButton.vue";
import GuardNoteItem from "@/components/mobile/dispatch/GuardNoteItem.vue";

const Mobile = namespace("mobile");

@Component({
	components: {
		"upload-file-button": UploadFileButton,
		"guard-note-item": GuardNoteItem
	}
})
export default class GuardNoteList extends Vue {
	public eventNote = "";
	public eventId: number = 0;
	public expanded: boolean = true;
	public sendNoteProgress: number = 0;
	public sendNoteStatus: string = "";
	public cancelUpload: boolean = false;
	private showCancelUpload: boolean = false;

	@Mobile.Getter("getActiveDispatchRequest") activeDispatchRequest: DispatchRequest;
	@Mobile.Action addNoteForEvent: any;
	@Mobile.Getter("getGuardId") guardId: number;
	@Mobile.Getter("getDispatchNotesForEvent") notesForEvent: DispatchNote[];
	@Mobile.Action loadNotesForEvent: any;
	@Mobile.Getter("getMobileFeatures") getMobileFeatures: MobileFeatures;
	@Mobile.Mutation setNotificationText: any;

	@Prop(Boolean)
	public saveNoteForFinish: boolean;

	@Watch("activeDispatchRequest")
	onActivatedDispatchRequest(value: DispatchRequest, oldValue: DispatchRequest) {
		if (typeof value !== "undefined") {
			this.eventId = value.eventID;
		}
	}

	@Watch("saveNoteForFinish", { deep: true })
	onSaveNoteForFinishChanged(value: boolean, oldValue: boolean) {
		this.sendNote();
	}

	mounted() {
		this.getNotes();
	}

	beforeDestroy() {
		this.stopGettingNotes();
	}

	private areThereNotes() {
		return typeof this.notesForEvent !== "undefined";
	}

	private toggleExpandUpdate() {
		this.expanded = !this.expanded;
	}

	private scrollToBottom() {
		var scrollableNotesHistoryElement = this.$refs.scrollableNotesHistory as HTMLElement;
		if (scrollableNotesHistoryElement) {
			scrollableNotesHistoryElement.scrollTop = scrollableNotesHistoryElement.scrollHeight;
		}
	}

	private resetProgressBar() {
		setTimeout(
			function() {
				this.sendNoteProgress = 0;
			}.bind(this),
			1000
		);
	}

	public async sendNote() {
		if (typeof this.eventId === "undefined" || this.eventId === null) {
			return;
		}

		if (this.eventNote !== "") {
			if (this.activeDispatchRequest !== null && typeof this.activeDispatchRequest !== "undefined") {
				this.eventId = this.activeDispatchRequest.eventID;
				this.sendNoteProgress = 1;

				await this.addNoteForEvent({
					guardNote: this.eventNote,
					eventId: this.eventId
				});

				this.sendNoteProgress = 50;

				await this.loadNotesForEvent(this.eventId);
				this.sendNoteProgress = 100;

				this.scrollToBottom();
				this.resetProgressBar();

				this.eventNote = "";
			}
		}
	}

	// On a 5 second interval, get the notes for the event
	private getNotesInterval = null;
	private getNotes() {
		clearInterval(this.getNotesInterval);
		this.getNotesInterval = setInterval(
			function() {
				this.loadNotesForEvent(this.eventId);
			}.bind(this),
			5000
		);
	}

	private stopGettingNotes() {
		clearInterval(this.getNotesInterval);
		this.getNotesInterval = null;
	}

	public autoSizeEventNote() {
		var eventNoteElement = this.$refs.eventNote as HTMLElement;
		setTimeout(
			function() {
				if (eventNoteElement) {
					eventNoteElement.style.cssText = "height:auto; padding:0";
					eventNoteElement.style.cssText = "height:" + eventNoteElement.scrollHeight + "px";
				}
			}.bind(this),
			0
		);
	}

	private isUploading(data) {
		if (typeof data.state.name !== "undefined" && data.state.name !== "") {
			this.showCancelUpload = true;
		} else {
			this.showCancelUpload = false;
		}
	}

	private uploadProgress(data) {
		this.sendNoteProgress = data.progress;
	}

	private uploadError(data) {
		this.setNotificationText(`Upload failed (error: ${data.error})`);
		this.resetProgressBar();
		this.scrollToBottom();
	}

	private uploadSuccess() {
		this.setNotificationText("Upload successful");
		this.resetProgressBar();
		this.scrollToBottom();
	}

	private cancelAndReset() {
		this.cancelUpload = true;
		this.showCancelUpload = false;
		this.resetProgressBar();
		this.scrollToBottom();
		this.setNotificationText("Upload cancelled by user");
		// Wait for a small amount of time to reset the prop
		setTimeout(
			function() {
				this.cancelUpload = false;
			}.bind(this),
			1000
		);
	}
}
